import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appEqualHeight]'
})
export class EqualHeightDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setEqualHeight();  
    }, 100);
    
  }

  @HostListener('window:resize')
  onResize() {
    this.setEqualHeight();
  }

  private setEqualHeight() {
    const parent = this.el.nativeElement;
    const children = parent.querySelectorAll('.equal-height');
    const heights = [];

    // Reset heights
    children.forEach((child: HTMLElement) => {
      this.renderer.setStyle(child, 'min-height', '');
    });

    // Calculate heights
    children.forEach((child: HTMLElement) => {
      heights.push(child.offsetHeight);
    });

    // Find max height
    const maxHeight = Math.max(...heights);

    // Set min-height to max height
    children.forEach((child: HTMLElement) => {
      this.renderer.setStyle(child, 'min-height', `${maxHeight}px`);
    });
  }
}